import React from 'react';
import PropTypes from 'prop-types';
import {
  Modal as BoortsrapModal,
  ModalHeader,
  ModalBody,
  ModalFooter
} from 'reactstrap';
import Button from '../Button';
import styles from './styles.scss';


export default class Modal extends React.Component {
  static get propTypes() {
    return {
      isOpen: PropTypes.bool,
      header: PropTypes.string,
      children: PropTypes.node,
      onConfirm: PropTypes.func,
      onCancel: PropTypes.func,
      showConfirmButton: PropTypes.bool,
      showCancelButton: PropTypes.bool,
      cancelButtonText: PropTypes.string,
      confirmButtonText: PropTypes.string,
      confirmButtonType: PropTypes.string,
      confirmButtonLoading: PropTypes.bool,
      size: PropTypes.string,
      fullSizeModal: PropTypes.bool,
      showHeaderCancel: PropTypes.bool
    }
  }

  static get defaultProps() {
    return {
      isOpen: false,
      confirmButtonText: 'Confirm',
      confirmButtonType: 'primary',
      showConfirmButton: true,
      showCancelButton: true,
      size: 'md',
      showHeaderCancel: false
    }
  }

  render() {
    const {
      isOpen,
      header,
      children,
      onConfirm,
      onCancel,
      cancelButtonText,
      confirmButtonText,
      confirmButtonLoading,
      confirmButtonType,
      showConfirmButton,
      showCancelButton,
      size,
      fullSizeModal,
      showHeaderCancel
    } = this.props;
    const confirmText = confirmButtonLoading ?
      <i className='fa fa-spin fa-spinner' /> :
      confirmButtonText;
    return (
      <BoortsrapModal style={fullSizeModal ? { maxWidth: '1200px', width: '80%' } : {}} size={size} isOpen={isOpen}>
        <If condition={header}>
          <ModalHeader>
            <strong>{header}</strong>
            { showHeaderCancel && <button type="button" className={styles.close} data-dismiss="modal" aria-label="Close" onClick={onCancel}>
              <span aria-hidden="true">&times;</span>
            </button> }
          </ModalHeader>
        </If>
          <ModalBody className={styles.modal.body}>
            {children}
          </ModalBody>
        <ModalFooter>
          <If condition={showCancelButton}>
            <Button
              kind='primary'
              onClick={onCancel}
            >
              {cancelButtonText ? cancelButtonText : 'Cancel' }
            </Button>
          </If>
          <If condition={showConfirmButton}>
            <Button
              kind={confirmButtonType}
              onClick={onConfirm}
              disabled={confirmButtonLoading}>
              {confirmText}
            </Button>
          </If>
        </ModalFooter>
      </BoortsrapModal>
    );
  }
}



// WEBPACK FOOTER //
// src/components/shared/Modal/index.jsx